import { Currency, CardScheme, type CountryData } from "@/types";

const COUNTRY_DATA: CountryData[] = [
  {
    currency: Currency.SAR,
    isoCode2: "SA",
    isoCode3: "SAU",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_SAU,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_SAU_V2,
    applePayAllowed: true,
    cardsAllowed: [
      CardScheme.MADA,
      CardScheme.MASTERCARD,
      CardScheme.VISA,
      CardScheme.AMEX,
    ],
  },
  {
    currency: Currency.AED,
    isoCode2: "AE",
    isoCode3: "ARE",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_ARE,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_ARE_V2,
    applePayAllowed: true,
    cardsAllowed: [CardScheme.MASTERCARD, CardScheme.VISA],
  },
  {
    currency: Currency.KWD,
    isoCode2: "KW",
    isoCode3: "KWT",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_KWD,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_KWD_V2,
    applePayAllowed: false,
    cardsAllowed: [CardScheme.MASTERCARD, CardScheme.VISA],
  },
  {
    currency: Currency.QAR,
    isoCode2: "QA",
    isoCode3: "QAT",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_QAR,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_QAR_V2,
    applePayAllowed: true,
    cardsAllowed: [CardScheme.MASTERCARD, CardScheme.VISA],
  },
  {
    currency: Currency.BHD,
    isoCode2: "BH",
    isoCode3: "BHR",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_BHD,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_BHD_V2,
    applePayAllowed: true,
    cardsAllowed: [CardScheme.MASTERCARD, CardScheme.VISA],
  },
  {
    currency: Currency.OMR,
    isoCode2: "OM",
    isoCode3: "OMN",
    ckoPublicKey: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_OMN,
    ckoPublicKeyV2: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_OMN_V2,
    applePayAllowed: false,
    cardsAllowed: [CardScheme.MASTERCARD, CardScheme.VISA],
  },
];

export default COUNTRY_DATA;
